module.exports = __webpack_public_path__ + "components/flag/static/square/pt-2b402ccc48e769c150e1894a2f137b94.svg";